@if (isLoading) {
  <app-spinner [isLoading]="isLoading" />
} @else {
  <div class="client-notifications">
    @if (notifications && notifications.totalCount === 0) {
      <p class="no-notifications">
        {{ 'pages.client.noNotifications' | translate }}
      </p>
    }
    @for (notification of notifications?.list || []; track notification.id) {
      <div class="notification d-flex justify-content-between" [ngClass]="{ unread: !notification.isRead }">
        <p class="body" [innerHTML]="removeLinks(notification.textLatvian)"></p>
        <p class="datetime">
          {{ formatDateTime(notification.createdOn, false) }}
        </p>
      </div>
    }
  </div>
  @if (notifications && notifications.totalCount! > 10) {
    <div class="pagination-wrapper">
      <p class="total">
        {{ 'components.table.total' | translate }}
        {{ notifications.totalCount }}
      </p>
      @if (notifications.totalCount! > pageSize) {
        <ngb-pagination
          [(page)]="page"
          [pageSize]="pageSize"
          [collectionSize]="notifications.totalCount!"
          [maxSize]="5"
          [ellipses]="true"
          (pageChange)="onPageChange()" />
      }
      <select class="page-size" (change)="onPageSizeChange($event)">
        <option [selected]="pageSize === 10" [value]="10">10 / {{ 'components.table.pageSize' | translate }}</option>
        <option [selected]="pageSize === 20" [value]="20">20 / {{ 'components.table.pageSize' | translate }}</option>
        <option [selected]="pageSize === 50" [value]="50">50 / {{ 'components.table.pageSize' | translate }}</option>
        <option [selected]="pageSize === 100" [value]="100">100 / {{ 'components.table.pageSize' | translate }}</option>
      </select>
    </div>
  }
}
